import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'
import { memo } from 'react'

import { type IconSize, PIXELS_PER_ICON_SIZE } from '../../foundations/icon/sizes.ts'
import { colorTokens } from '../../foundations/index.ts'

export type SpinnerProps = {
  size?: IconSize
  className?: string | undefined
  strokeColor?: string
}

export const Spinner = memo<SpinnerProps>(function Spinner({ size = '70', className, strokeColor }) {
  const dimension = PIXELS_PER_ICON_SIZE[size]
  const sizePx = Number.parseInt(dimension, 10)
  return <StyledSpinner size={sizePx} {...(className ? { className } : {})} {...(strokeColor ? { strokeColor } : {})} />
})

const StyledSpinner = styled(CircularProgress, {
  shouldForwardProp: (prop) => prop !== 'strokeColor',
})<{ strokeColor?: string }>`
  & .MuiCircularProgress-circle {
    stroke-linecap: round;
    stroke: ${({ strokeColor }) => (strokeColor ? strokeColor : colorTokens['color-fg-base-active-inverse'])};
  }
`
